export default "__VITE_ASSET__AX6mKPJV__"